import { useSelector } from 'react-redux'
import { isNumber } from '.';
import { UserT } from '../types/Users';
import * as _ from 'lodash'
import { IAppState } from '../redux/reducers';

export const getCurrentUser = (): UserT | null => {
    let auth = useSelector((state: IAppState) => state.auth)
    return auth.userData && auth.userData
}


export const getCurrentUserRoles = (): Array<string> => {
    const currentUser = getCurrentUser()
    const roles = currentUser && currentUser.roles ? currentUser.roles : []
    return roles
}

export const getCurrentUserId = (): number | null => {
    const currentUser = getCurrentUser()
    return currentUser && currentUser.id
}


export const currentUserIsManager = (includeAdministrator: boolean = true): boolean => {
    const roles = getCurrentUserRoles()
    if (!includeAdministrator) {
        return roles.includes('manager')
    }
    return roles.includes('administrator') || roles.includes('manager') || roles.includes('external_admin')
}


export const currentUserIsAdmin = (): boolean => {
    const roles = getCurrentUserRoles()
    return roles.includes('administrator')
}
export const currentUserIsExternalAdmin = (): boolean => {
    const roles = getCurrentUserRoles()
    return roles.includes('external_admin')
}

export const currentUserIsClient = (): boolean => {
    const roles = getCurrentUserRoles()
    return roles.includes('client')
}

export const currentUserIsWorker = (): boolean => {
    const roles = getCurrentUserRoles()
    return roles.includes('worker')
}



export const currentUserCompanyId = (): number | null => {
    const currentUser = getCurrentUser()
    if (!currentUser) {
        return null
    }
    if (_.has(currentUser, 'defaultCompany') && currentUser.defaultCompany > 0 && isNumber(currentUser.defaultCompany)) {
        return currentUser.defaultCompany;
    }

    let fk_companies = _.has(currentUser, 'fk_companies') && _.isArray(currentUser.fk_companies) ? currentUser.fk_companies : []

    if (fk_companies.length > 0 && fk_companies[0]) {
        return fk_companies[0]
    }
    return null

}


export const currentCanViewFinancials = (): boolean => {
    const currentUser = getCurrentUser()
    if (!currentUser) {
        return false
    }
    if (_.has(currentUser, 'viewFinancials') && currentUser.viewFinancials == true) {
        return true
    }

    return false

}